// Over and out: inner
const __onOver = function(sprite) {
    let filter = new PIXI.ColorMatrixFilter();
    filter.brightness(1.5, true);
    filter.hue(40, true);
    filter.saturate(1.5, true);
    sprite.filters = [filter];
}

const __onOut = function(sprite) {
    sprite.filters = undefined;
}

//------------------------------------------------------------
// Over and out: outer
export function onOver(sprite) {
    sprite.eventMode = 'static';
    sprite.cursor = 'pointer';

    sprite.__onOver = () => __onOver(sprite);
    sprite.__onOut  = () => __onOut(sprite);

    sprite.on('pointerover', sprite.__onOver)
    sprite.on('pointerout',  sprite.__onOut);
}

export function offOver(sprite) {
    sprite.eventMode = 'passive';
    sprite.cursor = 'auto';

    sprite.off('pointerover', sprite.__onOver)
    sprite.off('pointerout',  sprite.__onOut);
    if (typeof(sprite.__onOut) === 'function') sprite.__onOut();

    delete sprite.__onOver;
    delete sprite.__onOut;
}

//------------------------------------------------------------
let isLock = false;

// On click
export function onClick(sprite, cb) {
    onOver(sprite);
    sprite.__click = async () => {
        if (isLock) return;
        isLock = true;
        await cb();
        isLock = false;
    };
    sprite.on('pointerdown', sprite.__click);
}

// Off click
export function offClick(sprite) {
    offOver(sprite);
    sprite.off('pointerdown', sprite.__click);
    delete sprite.__click;
}
